export class TravelLineTicket {
    id:number = 0;
    ticket_number:string = '';
    tara_date:string = '';
    tara_hour:string = '';
    bruto_date:string = '';
    bruto_hour:string = '';
    tara:number = 0;
    bruto:number = 0;
    neto:number = 0;
    travel_line_id:number = 0;
}
